<template>
  <div :class="$style['login_bg']">
    <div :class="$style.overlay"></div>
    <div :class="$style.center">
      <slot></slot>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'landing'
  }
</script>
<style module>
  .overlay {
    position:fixed;
    top: 0;right: 0;left: 0;bottom: 0;
    background:rgba(0,0,0,0.2);
  }
  .login_bg {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0px;
    bottom: 0px;
    background: #f1f1f1;
    background: url(../../assets/images/inesajxjy/banner.jpg) center center no-repeat;
    background-size: 100%;
    z-index: 0;
    overflow:hidden; word-break:break-all;
  }
  .center {
    width: 440px;
    border-radius:6px;
    background:#fff;
    left:50%;
    box-shadow: 1px 1px 6px rgba(0, 0, 0, 0.3);
    margin-left: -220px;
    position:absolute;
  }
</style>



// WEBPACK FOOTER //
// src/pages/others/landing.vue